/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  cddCustomerTypeOptions,
  // cddFilterOPtions,
  cddOptions,
  defaultLimitPagination,
  get,
  riskProfile,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { useLocation } from "react-router-dom";
import {
  formatMobile,
  formatName,
  formatPhone,
  getModuleNamingBySlug,
} from "../../../lib/Misc";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../../components/Pagination";
import MainBody from "../../../components/MainBody/MainBody";
import sortCaret from "../../../components/SortCaret";
import { useTrust } from "../../../lib/context/TrustContext";
import { Button } from "../../../components/ui/button";
import {
  Calendar,
  CalendarCheck,
  CalendarClockIcon,
  CheckCircle2,
  Clock,
  Clock3,
  Landmark,
  SearchCheck,
} from "lucide-react";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import ExpandCDD from "./ExpandCDD";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import VerifyModal from "./VerifyModal";
import RiskChange from "./RiskChange";
import UnauthorisedAccess from "../../../UnauthorisedAccess";
import AddEditContact from "../../Contacts/AddEditContact";
import { AMLCTFModuleConditonIndustry } from "../../../lib/PermissionConditions";
import { useUser } from "../../../lib/context/UserContext";
import AddEditVendor from "../../Vendors/AddEditVendor";
import CDDVerifyModal from "../../../components/Assessment_KYC/CDDVerifyModal";
import CDDVerifyCheck from "../../../components/Assessment_KYC/CDDVerifyCheck";
import KYBReportDownload from "../../../components/Assessment_KYC/KYBReportDownload";
import AdverseMedia from "../../../components/Assessment_KYC/AdverseMedia";
import CDDStatus from "../../../components/Assessment_KYC/CDDStatus";
import { AnimatedTooltip } from "../../../components/AnimatedTooltip";
import moment from "moment";
// import { Label } from "../../../components/ui/label";
// import CustomLabelText from "../../../components/CustomLabelText";
// import SearchSelect from "../../../components/SearchSelect";
import NameUpdate from "./NameUpdate";
import KYCIncomplete from "./KYCIncomplete";

// * Start: Vendor Listing Page
const CommonCDD = ({ readAccess, type, startDate, endDate }) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page") || 1;
  const defaultLimit = query.get("limit") || defaultLimitPagination;
  // const defaultFilter = query.get("filter") || null;
  const { organizationData } = useOrganization();
  const { userData } = useUser();

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;

  // * End: Url Management State

  // * Start: List Management State

  const { trustId } = useTrust();
  const [simplifiedCDDsList, setSimplifiedCDDsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [cddId, setCddId] = useState("");
  const [cddItem, setCddItem] = useState("");

  const [showVisual, setShowVisual] = useState(false);
  const [showRisk, setShowRisk] = useState(false);

  const [edit, setEdit] = useState(false);
  const [onlyKyc, setOnlyKyc] = useState(false);

  const [contactId, setContactId] = useState(null);
  const [showAddEditContact, setShowAddEditContact] = useState(false);

  const [vendorId, setVendorId] = useState(null);
  const [showAddEditVendor, setShowAddEditVendor] = React.useState(false);

  // const [filterValue, setFilterValue] = useState(defaultFilter || null);

  const toggleShowAddEditContact = () => {
    if (showAddEditContact) {
      setEdit(false);
      setOnlyKyc(false);
      setContactId(null);
    }
    setShowAddEditContact(!showAddEditContact);
  };

  const toggleShowAddEditVendor = () => {
    if (showAddEditVendor) {
      setEdit(false);
      setOnlyKyc(false);
      setVendorId(null);
    }
    setShowAddEditVendor(!showAddEditVendor);
  };

  // * End: List Management State

  /**
   * * Start: Fetch Vendor List Form The API
   * @param {Number} passLimit (Number of Limit for each page)
   * @param {Number} passPage (Number of Page for records)
   * @returns {Array} Vendor List
   **/

  const fetchCommonCDDs = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.GET_AML_DASHBOARD_DETAILS}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&organization_id=${
            organizationData?.organizationId
              ? organizationData?.organizationId
              : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }&type=${type}&start_date=${startDate || ""}&end_date=${endDate || ""}`,
        );
        setLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const simplifiedCDDsList = data.data.data;
        setSimplifiedCDDsList(simplifiedCDDsList);
        return data.data;
      } catch (error) {
        setSimplifiedCDDsList([]);
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sortOrder, sortField, organizationData],
  );

  //* End: Fetch Vendor List Form The API

  const toggleVisual = (id, data) => {
    if (showVisual) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowVisual(!showVisual);
  };

  const toggleRisk = (id, data) => {
    if (showRisk) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowRisk(!showRisk);
  };

  /**
   * * Start: Vendor Table List Record Generation
   * @param {Number} quantity (Number of SimplifiedCDDs)
   * @returns {Array} Vendor List
   **/

  const simplifiedCDDsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      let smsDate = simplifiedCDDsList[i]?.verifications[0]?.sms_sent_date
        ? simplifiedCDDsList[i]?.verifications[0]?.sms_sent_date
        : "";
      let contact = simplifiedCDDsList[i]?.joint_account_id
        ? simplifiedCDDsList[i]?.joint_account
        : simplifiedCDDsList[i]?.beneficiary_id
          ? simplifiedCDDsList[i]?.beneficiary
          : simplifiedCDDsList[i]?.vendor_id
            ? simplifiedCDDsList[i]?.vendor
            : simplifiedCDDsList[i]?.contact_id
              ? simplifiedCDDsList[i]?.contact
              : "";

      contact.mobile = contact?.mobile
        ? contact?.mobile[0] === "+"
          ? contact?.mobile
          : `+${contact?.mobile}`
        : "";
      items.push({
        key: simplifiedCDDsList[i]?.id,
        id: simplifiedCDDsList[i]?.id ? simplifiedCDDsList[i]?.id : "",
        not_matched: simplifiedCDDsList[i]?.not_matched,
        cdd_customer_type: cddCustomerTypeOptions?.find(
          (item) => item.value == simplifiedCDDsList[i]?.cdd_customer_type,
        )?.label,
        cdd: cddOptions?.find(
          (item) => item.value == simplifiedCDDsList[i]?.cdd,
        )?.label,
        contact_type: simplifiedCDDsList[i]?.joint_account_id
          ? "Joint Account"
          : simplifiedCDDsList[i]?.beneficiary_id
            ? "Beneficiary"
            : simplifiedCDDsList[i]?.vendor_id
              ? getModuleNamingBySlug(
                  organizationData?.organizationData,
                  "vendors",
                  "Vendor",
                )
              : simplifiedCDDsList[i]?.contact_id
                ? getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "contacts",
                    "Customer",
                  )
                : "",
        code: contact?.code ? contact?.code : "",
        name: (
          <div className="flex items-center justify-between gap-3">
            <div>
              {formatName(contact?.first_name, contact?.last_name) +
                (contact?.business_name ? ` (${contact?.business_name})` : "")}
            </div>

            <NameUpdate
              contactData={{
                first_name: contact?.first_name ? contact?.first_name : "",
                last_name: contact?.last_name ? contact?.last_name : "",
                dob: contact?.dob ? contact?.dob : "",
                street: contact?.street ? contact?.street : "",
                suburb_id: contact?.suburb_id ? contact?.suburb_id : "",
                suburb: contact?.suburb?.name ? contact?.suburb?.name : "",
                state_id: contact?.state_id ? contact?.state_id : "",
                state: contact?.state?.short_name
                  ? contact?.state?.short_name
                  : "",
                postal_code: contact?.postal_code ? contact?.postal_code : "",
              }}
              kycData={{
                first_name: simplifiedCDDsList[i]?.match_details?.name
                  ?.first_name
                  ? simplifiedCDDsList[i]?.match_details?.name?.first_name
                  : "",
                last_name: simplifiedCDDsList[i]?.match_details?.name?.last_name
                  ? simplifiedCDDsList[i]?.match_details?.name?.last_name
                  : "",
                dob: simplifiedCDDsList[i]?.match_details?.date_of_birth
                  ? simplifiedCDDsList[i]?.match_details?.date_of_birth
                  : "",
                street: simplifiedCDDsList[i]?.match_details?.address?.street
                  ? simplifiedCDDsList[i]?.match_details?.address?.street
                  : "",
                suburb_id: simplifiedCDDsList[i]?.match_details?.address
                  ?.suburb_id
                  ? simplifiedCDDsList[i]?.match_details?.address?.suburb_id
                  : "",
                suburb: simplifiedCDDsList[i]?.match_details?.address?.suburb
                  ? simplifiedCDDsList[i]?.match_details?.address?.suburb
                  : "",
                state_id: simplifiedCDDsList[i]?.match_details?.address
                  ?.state_id
                  ? simplifiedCDDsList[i]?.match_details?.address?.state_id
                  : "",
                state: simplifiedCDDsList[i]?.match_details?.address?.state
                  ? simplifiedCDDsList[i]?.match_details?.address?.state
                  : "",
                postal_code: simplifiedCDDsList[i]?.match_details?.address
                  ?.post_code
                  ? simplifiedCDDsList[i]?.match_details?.address?.post_code
                  : "",
                match_details: simplifiedCDDsList[i]?.match_details
                  ? simplifiedCDDsList[i]?.match_details
                  : "",
              }}
              id={simplifiedCDDsList[i]?.id ? simplifiedCDDsList[i]?.id : ""}
              fetchData={() => fetchCommonCDDs(limit, page)}
              matchDetailsUpdated={simplifiedCDDsList[i]?.match_details_updated}
            />
          </div>
        ),
        email: contact?.email,
        phone: contact?.phone ? formatPhone(contact?.phone) : "-",
        mobile: contact?.mobile ? formatMobile(contact?.mobile) : "-",
        contact: contact,
        risk: (
          <div className="flex items-center gap-2">
            {simplifiedCDDsList[i]?.risk
              ? riskProfile?.find(
                  (item) => item.value == simplifiedCDDsList[i]?.risk,
                )?.label
              : ""}{" "}
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    toggleRisk(
                      simplifiedCDDsList[i]?.id,
                      simplifiedCDDsList[i],
                    );
                  }}
                />
              </span>
            </CustomTooltip>
          </div>
        ),
        source: simplifiedCDDsList[i]?.source ? (
          simplifiedCDDsList[i]?.source?.includes("(SMS)") ? (
            <div className="flex items-center gap-2">
              {simplifiedCDDsList[i]?.source}{" "}
              {smsDate && (
                <AnimatedTooltip
                  title={
                    <div className="flex items-center gap-4 text-sm">
                      <span>SMS Sent Date:</span>
                      <span className="flex items-center gap-1.5">
                        <Calendar className="h-4 w-4" />
                        {moment(smsDate, "DD-MM-YYYY HH:mm:ss").format(
                          "DD MMM YYYY",
                        )}
                      </span>

                      <span className="flex items-center gap-1.5">
                        <Clock3 className="h-4 w-4" />
                        {moment(smsDate, "DD-MM-YYYY HH:mm:ss").format(
                          "hh:mm:ss A",
                        )}
                      </span>
                    </div>
                  }
                >
                  <CalendarClockIcon className="h-4 w-4 text-webPrimary" />
                </AnimatedTooltip>
              )}
            </div>
          ) : (
            simplifiedCDDsList[i]?.source
          )
        ) : (
          // "KYC Incomplete"
          ""
        ),
        verifications: simplifiedCDDsList[i]?.verifications
          ? simplifiedCDDsList[i]?.verifications
          : "",
        bureau: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.joint_account_id
                ? "joint account"
                : simplifiedCDDsList[i]?.beneficiary_id
                  ? "beneficiary"
                  : simplifiedCDDsList[i]?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : simplifiedCDDsList[i]?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"bureau"}
            fetchData={() => fetchCommonCDDs(limit, page)}
          />
        ),
        dvs: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.joint_account_id
                ? "joint account"
                : simplifiedCDDsList[i]?.beneficiary_id
                  ? "beneficiary"
                  : simplifiedCDDsList[i]?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : simplifiedCDDsList[i]?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"dvs"}
            fetchData={() => fetchCommonCDDs(limit, page)}
          />
        ),
        pep: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.joint_account_id
                ? "joint account"
                : simplifiedCDDsList[i]?.beneficiary_id
                  ? "beneficiary"
                  : simplifiedCDDsList[i]?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : simplifiedCDDsList[i]?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"pep"}
            fetchData={() => fetchCommonCDDs(limit, page)}
          />
        ),
        sanction: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.joint_account_id
                ? "joint account"
                : simplifiedCDDsList[i]?.beneficiary_id
                  ? "beneficiary"
                  : simplifiedCDDsList[i]?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : simplifiedCDDsList[i]?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"sanction"}
            fetchData={() => fetchCommonCDDs(limit, page)}
          />
        ),
        adverse_media: (
          <AdverseMedia
            adverse_media_result={
              simplifiedCDDsList[i]?.summaries[0]?.adverse_media_result
            }
            reference_no={simplifiedCDDsList[i]?.summaries[0]?.request_id}
          />
        ),
        risk_assessment_action: (
          <span className="flex items-center gap-2 justify-center">
            {contact?.kyc?.risk_assessment && (
              <>
                <CustomTooltip
                  message={`Assessment Date: ${contact?.kyc?.risk_assessment?.assessment_date}`}
                >
                  <CalendarCheck size={16} />
                </CustomTooltip>
                <span>/</span>
              </>
            )}
            <CustomTooltip message={"Onboarding Assessment"}>
              <SearchCheck
                size={16}
                onClick={() => {
                  setOnlyKyc(true);
                  setEdit(true);
                  if (simplifiedCDDsList[i]?.vendor_id) {
                    toggleShowAddEditVendor();
                    setVendorId(contact?.id);
                  }
                  if (simplifiedCDDsList[i]?.contact_id) {
                    toggleShowAddEditContact();
                    setContactId(contact?.id);
                  }
                }}
              />
            </CustomTooltip>
          </span>
        ),
        kyc: simplifiedCDDsList[i] ? simplifiedCDDsList[i] : "",
        action:
          simplifiedCDDsList[i]?.source !== "Multiple" ? (
            <>
              <span className="flex items-center gap-2 justify-center">
                {simplifiedCDDsList[i]?.kyb_report_file ? (
                  <KYBReportDownload
                    setLoading={setLoading}
                    kyb_report_file={simplifiedCDDsList[i]?.kyb_report_file}
                  />
                ) : (
                  <></>
                )}
                {(simplifiedCDDsList[i]?.kyb_report_file &&
                  simplifiedCDDsList[i]?.status === 1) ||
                simplifiedCDDsList[i]?.status === 1 ? (
                  <Button
                    size={"sm"}
                    className={
                      contact?.type == 2
                        ? "bg-green-800 hover:bg-green-900 text-white h-6 px-2"
                        : "bg-green-500 hover:bg-green-600 text-white h-6 px-2"
                    }
                  >
                    <div className="flex items-center gap-1">
                      {contact?.type == 2 ? (
                        <Landmark size={14} />
                      ) : (
                        <CheckCircle2 size={14} />
                      )}
                      <span>Verified</span>
                    </div>
                  </Button>
                ) : (simplifiedCDDsList[i]?.kyb_report_file &&
                    simplifiedCDDsList[i]?.status === 1) ||
                  simplifiedCDDsList[i]?.status === 2 ||
                  simplifiedCDDsList[i]?.status === 3 ? (
                  <>
                    <CDDVerifyModal
                      listData={simplifiedCDDsList[i]}
                      setCddItem={setCddItem}
                      setCddId={setCddId}
                      cddItem={cddItem}
                      customerType={contact?.type ? contact?.type : 1}
                      setLoading={setLoading}
                      cddId={cddId}
                      pending={true}
                      sectionType={simplifiedCDDsList[i]?.cdd_customer_type}
                      fecthData={fetchCommonCDDs}
                      cdd={simplifiedCDDsList[i]?.cdd}
                      defaultMobile={
                        contact?.mobile
                          ? contact?.mobile[0] === "+"
                            ? contact?.mobile
                            : `+${contact?.mobile}`
                          : ""
                      }
                      defaultABN={contact?.abn ? contact?.abn : ""}
                    />
                    <Button
                      size={"sm"}
                      className={
                        simplifiedCDDsList[i]?.status === 2
                          ? "bg-yellow-500 hover:bg-yellow-600 text-white h-6 px-2"
                          : "bg-red-500 hover:bg-red-600 text-white h-6 px-2"
                      }
                    >
                      <div className="flex items-center gap-1">
                        <Clock size={14} />
                        <span>
                          {simplifiedCDDsList[i]?.status === 2
                            ? "Pending"
                            : "Expired"}
                        </span>
                      </div>
                    </Button>
                    {simplifiedCDDsList[i]?.status === 2 ? (
                      <CDDVerifyCheck
                        listData={simplifiedCDDsList[i]}
                        setCddId={setCddId}
                        setLoading={setLoading}
                        cddId={cddId}
                        fecthData={fetchCommonCDDs}
                      />
                    ) : (
                      <></>
                    )}
                  </>
                ) : simplifiedCDDsList[i]?.source !== "Visual" ? (
                  simplifiedCDDsList[i]?.source ? (
                    <CDDVerifyModal
                      loading={loading}
                      listData={simplifiedCDDsList[i]}
                      setCddItem={setCddItem}
                      setCddId={setCddId}
                      cddItem={cddItem}
                      customerType={contact?.type ? contact?.type : 1}
                      setLoading={setLoading}
                      cddId={cddId}
                      sectionType={simplifiedCDDsList[i]?.cdd_customer_type}
                      fecthData={fetchCommonCDDs}
                      cdd={simplifiedCDDsList[i]?.cdd}
                      defaultMobile={
                        contact?.mobile
                          ? contact?.mobile[0] === "+"
                            ? contact?.mobile
                            : `+${contact?.mobile}`
                          : ""
                      }
                      defaultABN={contact?.abn ? contact?.abn : ""}
                    />
                  ) : (
                    // "KYC Incomplete"
                    <KYCIncomplete
                      contactType={
                        simplifiedCDDsList[i]?.joint_account_id
                          ? 4
                          : simplifiedCDDsList[i]?.beneficiary_id
                            ? 3
                            : simplifiedCDDsList[i]?.contact_id
                              ? 2
                              : simplifiedCDDsList[i]?.vendor_id
                                ? 1
                                : ""
                      }
                      amlCTFEnable={amlCTFEnable}
                      contact={contact}
                      type={contact?.type}
                      entityType={contact?.entity_type}
                      fetchData={() => fetchCommonCDDs(limit, page)}
                    />
                  )
                ) : (
                  <CustomTooltip message={"Edit"}>
                    <span>
                      <FontAwesomeIcon
                        icon={faEdit}
                        size="1x"
                        onClick={() => {
                          toggleVisual(
                            simplifiedCDDsList[i]?.id,
                            simplifiedCDDsList[i],
                          );
                        }}
                      />
                    </span>
                  </CustomTooltip>
                )}
              </span>
            </>
          ) : (
            <></>
          ),
      });
    }
    return items;
  };

  const simplifiedCDDs = simplifiedCDDsGenerator(simplifiedCDDsList?.length);

  //* End: Vendor Table List Record Generation

  //* Start: Vendor List Columns

  const columns = [
    {
      dataField: "contact_type",
      text: "Type",
      // sort: true,
      // sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "cdd_customer_type",
      text: "CDD Customer Type",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "cdd",
      text: "CDD Type",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "code",
      text: "Code",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "mobile",
      text: "Mobile No.",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "risk",
      text: "Risk Profile",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "source",
      text: "Source",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "dvs",
      text: "DVS",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "bureau",
      text: "Bureau",
      headerClasses: THClasses,
      classes: TDClasses,
    },

    {
      dataField: "pep",
      text: "PEP",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "sanction",
      text: "Sanction",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "adverse_media",
      text: "Adverse Media",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  //* End: Vendor List Columns

  /**
   * * Start: Vendor List Sorting
   * @param {type} (Sort)
   * @param {JSON} (page, sortField, sortOrder) (To get the current value of the table)
   **/
  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  //* End: Vendor List Sorting

  /**
   * * Start: Vendor List Change Limit
   * @param {Event} e (Limit Number)
   **/
  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchCommonCDDs(limit, 1);
  };

  //* End: Vendor List Change Limit

  /**
   * * Start: Vendor List Change Page
   * @param {Number} page (Page Number)
   **/
  const handleChangePage = (page) => {
    setPage(page);
    fetchCommonCDDs(limit, page);
  };

  //* End: Vendor List Change Page

  //* Start: Vendor List and URL Mangement useEffect

  useEffect(() => {
    fetchCommonCDDs();
  }, [fetchCommonCDDs]);

  //* End: Vendor List and URL Mangement useEffect

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandCDD
          expandList={true}
          expandData={row?.verifications}
          kyc={row?.kyc}
          loading={loading}
          setLoading={setLoading}
          fetchCDDs={fetchCommonCDDs}
          sectionType={row?.cdd_customer_type}
          contact={row?.contact}
        />
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  return readAccess ? (
    <>
      <MainBody
        actionContent={
          <>
            <div className="flex items-center gap-2">
              <div className="grid gap-2">
                {/* <div className="min-w-0 flex items-center gap-2">
                  <Label htmlFor="aml_ctf_contact_id">
                    <CustomLabelText labelText="Filter by:" errorField={""} />
                  </Label>
                  <div className="relative">
                    <SearchSelect
                      frameworks={cddFilterOPtions}
                      optionType={"Filter by"}
                      handleSelect={(e) => {
                        setFilterValue(e);
                      }}
                      clearable={true}
                      initialValue={filterValue ? filterValue : ""}
                      onClear={() => {
                        setFilterValue(null);
                      }}
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </>
        }
        search={false}
        loading={loading}
        innerBody={true}
        parentHeight={true}
        mainClassName="w-[calc(100%-2rem)]"
      >
        {/* Vendor Table and Pagination */}
        <div className="custom-table md:max-w-[92vw]">
          <div className="table-body-class max-h-[52vh] overflow-y-auto">
            <BootstrapTable
              keyField="id"
              remote
              data={simplifiedCDDs}
              columns={columns}
              onTableChange={handleTableChange}
              expandRow={expandRow}
              rowClasses={(row) => {
                if (row?.kyc?.match_details) {
                  return `${TRClasses} contact-not-match`;
                }
                if (row?.kyc?.match_details_updated) {
                  return `${TRClasses} contact-kyc-update`;
                }
                return TRClasses;
              }}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
        </div>

        {showVisual && (
          <ResponsiveDrawerForm
            description={""}
            title={`Visual Changes`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleVisual();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showVisual}
            buttonClassName={""}
            setOpen={setShowVisual}
            popupType={"cdds"}
          >
            <VerifyModal
              data={cddItem?.verifications[0]}
              toggleVisual={toggleVisual}
              fetchData={fetchCommonCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {showRisk && (
          <ResponsiveDrawerForm
            description={""}
            title={`Risk Change`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleRisk();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showRisk}
            popupType={"cdds"}
            buttonClassName={""}
            setOpen={setShowRisk}
          >
            <RiskChange
              data={cddItem}
              toggleRisk={toggleRisk}
              fetchData={fetchCommonCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {contactId ? (
          <ResponsiveDrawerForm
            description={""}
            title={
              onlyKyc
                ? `Contact Onboarding Assessment`
                : edit
                  ? `Edit ${getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )}`
                  : `Add ${getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )}`
            }
            handleOpen={() => {}}
            handleClose={() => {
              setEdit(false);
              setOnlyKyc(false);
              setContactId(null);
              setShowAddEditContact(false);
            }}
            buttonText={""}
            className={"overflow-hidden"}
            open={showAddEditContact}
            buttonClassName={""}
            setOpen={setShowAddEditContact}
            write={true}
          >
            <AddEditContact
              edit={edit}
              toggleShowAddEditContact={toggleShowAddEditContact}
              id={contactId}
              setEdit={setEdit}
              onlyKyc={onlyKyc}
              trustId={trustId}
              fetchContactData={() => fetchCommonCDDs(limit, page)}
              org={true}
              amlCTFEnable={amlCTFEnable}
            />
          </ResponsiveDrawerForm>
        ) : vendorId ? (
          <>
            <ResponsiveDrawerForm
              description={""}
              title={
                onlyKyc
                  ? `Vendor Onboarding Assessment`
                  : edit
                    ? `Edit ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )}`
                    : `Add ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )}`
              }
              handleOpen={() => {}}
              handleClose={() => {
                setEdit(false);
                setOnlyKyc(false);
                setVendorId(null);
                setShowAddEditVendor(false);
              }}
              buttonText={""}
              className={"overflow-hidden"}
              open={showAddEditVendor}
              buttonClassName={""}
              setOpen={setShowAddEditVendor}
              mobileCancelHidden={true}
              write={true}
            >
              <AddEditVendor
                edit={edit}
                setEdit={setEdit}
                onlyKyc={onlyKyc}
                toggleShowAddEditVendor={toggleShowAddEditVendor}
                vendorID={vendorId}
                fetchVendors={() => fetchCommonCDDs(limit, page)}
                org={true}
                amlCTFEnable={amlCTFEnable}
              />
            </ResponsiveDrawerForm>
          </>
        ) : (
          <></>
        )}
      </MainBody>
    </>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};

export default CommonCDD;
// * End: Vendor Listing Page
